/**
 * Build a REST path with every dynamic segment escaped.
 *
 * Session ids, key ids and repository names were interpolated raw, so a value
 * holding `?`, `#`, `/` or `%` silently moved the request to another route or
 * grew a query string the caller never wrote. A tagged template makes the safe
 * form the easy one, and the structural slashes stay in the literal parts.
 */
export function path(
  strings: TemplateStringsArray,
  ...values: string[]
): string {
  return strings.reduce(
    (accumulator, literal, index) =>
      accumulator +
      (index === 0 ? "" : encodeURIComponent(values[index - 1] ?? "")) +
      literal,
    "",
  );
}
